import React from "react"
import ArticleThumbnail from "../articleThumbnail"
import styles from "./NewsScroll.module.scss"

const NewsScroll = ({ articles }) => {
  return (
    <div className={styles.sectionWrapper}>
      <h3>Nyheter</h3>
      <div className={styles.container}>
        {articles
          // .filter((article) => article.mainImage)
          .slice(0, 10)
          .map((article, index) => (
            <div
              className={styles.articleWrapper}
              key={`article-${index}`}
              data-aos-fade
            >
              <ArticleThumbnail article={article} />
            </div>
          ))}
      </div>
    </div>
  )
}

export default NewsScroll
